import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend, backendRest } = clients.direct;
const adjustmentFields = {
  land: '',
  improvements: '',
  mobileHome: '',
  exemptions: '',
  totalTax: '',
  assessorPenalty: '',
  schoolDistrict: '',
  name: '',
};

const adjFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  schoolDistrict: '',
  adjDate: '',
  certDate: '',
  filedDate: '',
  adjOrUpd: '',
  type: '',
  certNumber: '',
  landVal: '',
  improvementVal: '',
  mobileVal: '',
  penaltyVal: '',
  totalExemptions: '',
  comments: '',
  taxAmt: '',
  posted: '',
  chunkID: '',
  invoiceNo: '',
  // Not a stored field - the server sets it only on the save it is answering, when the record
  // was filed under a date other than the one it would have carried (Create Omit / Create SA
  // forward shift onto the first day of the open posting period). Null on every read.
  postingPeriodNotice: '',
  valuesAfterAdjustment: {
    ...adjustmentFields,
  },
  valuesBeforeAdjustment: {
    ...adjustmentFields,
  },
};

const assessorNameAddressUpdateFields = {
  _id: '',
  importTaxId: '',
  importTaxYear: '',
  importOwnerId: '',
  importName1: '',
  importName2: '',
  importAddress1: '',
  importAddress2: '',
  importAddress3: '',
  importAddress4: '',
  importCity: '',
  importState: '',
  importZip: '',
  importDeedBk: '',
  importDeedPg: '',
  importGrantorName: '',
  importSaleDate: '',
  taxId: '',
  ownerId: '',
  name1: '',
  name2: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  city: '',
  state: '',
  zip: '',
  deedBk: '',
  deedPg: '',
  inCareOf1: '',
  inCareOf2: '',
  importCareOfName1: '',
  importCareOfName2: '',
  taxInquiryTransaction: '',
  isItUpadtedToTaxInquiryCollection: '',
};

const createWorkFile = {
  name: '',
  message: '',
  statusCodes: '',
};

const deleteAdjustmentsBulk = {
  status: '',
  message: '',
};

export const taxRollAdjustments = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    taxRollType: [],
    taxDistrict: [],
    lockedValues: false,
    assessorUpdateStats: {
      count: 0,
      misMatchedRecordsCount: 0,
    },
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setTaxRollType(state, items) {
      state.taxRollType = items;
    },
    setTaxDistrict(state, items) {
      state.taxDistrict = items;
    },
    setLockedValues(state, value) {
      state.lockedValues = value;
    },
    setAssessorUpdateStats(state, value) {
      state.assessorUpdateStats = value;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxAdjustments({ commit, dispatch }, {
      criteria, fields, baseCrudKey, postProcessTrans,
    }) {
      let results;
      const gqlfields = fields || adjFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxRollAdjustments($criteria: taxRollAdjustmentsCriteriaType) {
              taxRollAdjustments(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const dataList = postProcessTrans ? postProcessTrans(results.data.taxRollAdjustments)
            : results.data.taxRollAdjustments || [];
          commit('base/crud/setItems', [baseCrudKey, dataList], { root: true });
        }
        return results.data.taxRollAdjustments;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in getting Tax Roll Adjustments.', { root: true });
      }
      return [];
    },
    // fromCreateOmitOrSA marks the adjustment as one that Create Omit / Create SA is saving on
    // the user's behalf, so the resolver's Adjustment-program-access gate on NEW adjustments
    // does not apply to it - those two screens are gated on their own buttons.
    // throwOnError makes a failed save visible to the caller instead of flashing a generic
    // message and returning {}; Create Omit / Create SA use it to abort before they go on to
    // write the tax record.
    async upsertTaxRollAdjustments({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey, fromCreateOmitOrSA, throwOnError,
    }) {
      let results;
      try {
        const gqlfields = fields || adjFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxRollAdjustments ($item: taxRollAdjustmentsInputType!, $fromCreateOmitOrSA: Boolean)  {
                upsertTaxRollAdjustments(upsert: $item, fromCreateOmitOrSA: $fromCreateOmitOrSA) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
            fromCreateOmitOrSA,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxAdjTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTransaction = results.data ? (results.data.upsertTaxRollAdjustments
          || {}) : {};
        // A resolver that refused outright (403, closed posting period) already threw out of
        // backend.mutate; one that answered without a row lands here, and for a caller that is
        // about to write dependent records that is just as much a failure.
        if (throwOnError && !newTransaction._id) {
          throw new Error('the server did not return a saved adjustment');
        }
        if (newTransaction.posted !== undefined && newTransaction.posted === false) {
          newTransaction.posted = '';
        }
        // postingPeriodNotice is a message about THIS save, not a field of the row. Keep it out of
        // the crud list: an item taken from there and submitted again would carry it back, and
        // taxRollAdjustmentsInputType has no such field, so the mutation would be rejected
        // outright. The caller still gets it on the returned object.
        const { postingPeriodNotice, ...rowForList } = newTransaction;
        const newList = mergeByIdNewAtTop(taxAdjTransStateData || [], rowForList);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        if (throwOnError) throw e;
        // Surface the server's own message (e.g. missing Adjustment role) rather than always
        // flashing the generic string, which reads as a broken record instead of a permissions
        // problem.
        dispatch('flashError', (e && e.message) || 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async upsertCreateWorkFile({ dispatch, commit }, { upsert, fields }) {
      let results;
      try {
        const gqlfields = fields || createWorkFile;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertCreateWorkFile ($upsert: createWorkFileInputType!)  {
                upsertCreateWorkFile(upsert: $upsert) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { message } = results.data.upsertCreateWorkFile;
          dispatch('flashSuccess', `${message}`, { root: true });
          return results.data.upsertCreateWorkFile;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', (e && e.message) || 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async upsertCreateWorkFileForAssessorUpdate({ dispatch, commit }, { upsert, fields }) {
      let results;
      try {
        const gqlfields = fields || createWorkFile;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertCreateWorkFileForAssessorUpdate ($upsert: createWorkFileInputType!)  {
                upsertCreateWorkFileForAssessorUpdate(upsert: $upsert) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          return results.data.upsertCreateWorkFileForAssessorUpdate;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', (e && e.message) || 'There was a problem in upserting the work file for assessor update!', { root: true });
      }
      return {};
    },
    async bulkDeleteAdjustments({ dispatch, commit }, { upsert, fields }) {
      let results;
      try {
        const gqlfields = fields || deleteAdjustmentsBulk;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxRollAdjustmentsBulk ($upsert: createWorkFileInputType!)  {
                deleteTaxRollAdjustmentsBulk(upsert: $upsert) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { message } = results.data.deleteTaxRollAdjustmentsBulk;
          dispatch('flashSuccess', `${message}`, { root: true });
          return results.data.deleteTaxRollAdjustmentsBulk;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in deletion of adjustments!', { root: true });
      }
      return {};
    },
    async markedPostedRecords({ dispatch, commit }, { upsert }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertMarkPosted ($upsert: selectedPostInputType!)  {
                upsertMarkPosted(upsert: $upsert) {
                   status,
                   error
                  }
                }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { status, error } = results.data.upsertMarkPosted;
          if (status) {
            dispatch('flashSuccess', 'Selected Records are posted', { root: true });
            // channel for tax-inquiry reload
            const bcTaxInquiry = new BroadcastChannel('tax_inquiry_channel');
            bcTaxInquiry.postMessage('reload');
          } else {
            dispatch('flashError', `${error}`, { root: true });
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async getTaxTypes({ dispatch, commit }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            taxTypes { type }
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxTypes } = results.data;
          return taxTypes.type;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in getting tax types!', { root: true });
      }

      return results;
    },
    async getAssessorNameAddressUpdateFiles({ commit, dispatch },
      { criteria, baseCrudKey, postProcessTrans }) {
      let results;
      const gqlfields = assessorNameAddressUpdateFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query getAssessorNameAddressUpdateFiles($criteria: assessorNameAddressUpdateFilesCriteriaType) {
              getAssessorNameAddressUpdateFiles(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const taxData = results.data.getAssessorNameAddressUpdateFiles || [];
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxData) : taxData;
          commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        }
        return results.data.getAssessorNameAddressUpdateFiles;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in getting name and address update.', { root: true });
      }
      return [];
    },
    async getAssessorNameAddressUpdateFilesStats({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
                getAssessorNameAddressUpdateFilesStats { count, misMatchedRecordsCount }
              }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { getAssessorNameAddressUpdateFilesStats } = results.data;
          const obj = {
            count: getAssessorNameAddressUpdateFilesStats.count || 0,
            misMatchedRecordsCount: getAssessorNameAddressUpdateFilesStats.misMatchedRecordsCount
            || 0,
          };
          commit('setAssessorUpdateStats', obj);
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max date ranges.', { root: true });
      }
    },
    async upsertAssessorNameAddressUpdateFiles({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertAssessorNameAddressUpdateFiles($item:assessorNameAddressUpdateFilesInputType) {
            upsertAssessorNameAddressUpdateFiles(upsert:$item) {
              statusCodes,
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { upsertAssessorNameAddressUpdateFiles } = results.data;
        if (upsertAssessorNameAddressUpdateFiles.statusCodes === 200) {
          dispatch('flashSuccess', 'Tax inquiry record updated successfully', { root: true });
          return true;
        }
        dispatch('flashError', 'There was a problem while updating name/address on tax inquiry record!', { root: true });
        return false;
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating name/address on tax inquiry record!', { root: true });
      }
      return false;
    },
    async upsertAllAssessorNameAddressUpdateFiles({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertAllAssessorNameAddressUpdateFiles($item:allAssessorNameAddressUpdateFilesInputType) {
            upsertAllAssessorNameAddressUpdateFiles(upsert:$item) {
              statusCodes,
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { upsertAllAssessorNameAddressUpdateFiles } = results.data;
        if (upsertAllAssessorNameAddressUpdateFiles.statusCodes === 200) dispatch('flashSuccess', 'Tax inquiry record updated successfully', { root: true });
        else dispatch('flashError', 'There was a problem while updating name/address on tax inquiry record!', { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating name/address on tax inquiry record!', { root: true });
      }
      return {};
    },
    // Kick off the background "second pass": treasurer records (current tax year,
    // totalDue > 0) that have no match in the just-imported assessor file. Returns
    // { jobId }; the component then polls getAssessorSecondPassReportStatus.
    async startAssessorSecondPassReport({ dispatch }) {
      try {
        await dispatch('reAuth', null, { root: true });
        const { data } = await backendRest.get('/taxInquiry/assessor-second-pass/async');
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'There was a problem starting the missing-records report.', { root: true });
      }
      return null;
    },
    async getAssessorSecondPassReportStatus({ dispatch }, { jobId }) {
      try {
        await dispatch('reAuth', null, { root: true });
        const { data } = await backendRest.get(`/taxInquiry/assessor-second-pass/job/${jobId}`);
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
      }
      return null;
    },
    async adjustmentCertCheck({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query adjustmentCertCheck($criteria: adjustmentCertInputType) {
              adjustmentCertCheck(criteria: $criteria) {
                status,
                message,
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return results.data.adjustmentCertCheck;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in finding the adjustments records', { root: true });
      }
      return [];
    },
  },
};

export default taxRollAdjustments;
